import React from 'react';
import Loader from './Loader';
import NoData from '../common/NoData';

/**
 * Generic admin data table wrapper.
 *
 * Props:
 * - loading: boolean – whether data is loading
 * - hasRows: boolean – true if there is at least one row
 * - caption?: string – message for the loader
 * - minHeight?: string – min height for loader container (e.g. '400px')
 * - children: ReactNode – the actual <table> element
 * - emptyMessage?: string – optional custom empty message
 */
function DataTable({
  loading,
  hasRows,
  caption = 'Loading...',
  minHeight = '300px',
  children,
  emptyMessage,
}) {
  return (
    <div className="rounded-2xl border border-gray-100 bg-white overflow-hidden shadow-sm">
      <div className="overflow-x-auto">
        {loading ? (
          <Loader caption={caption} containerHeight={minHeight} />
        ) : (
          <>
            {hasRows ? (
              children
            ) : (
              <div className="text-center py-6">
                {emptyMessage ? <p className="text-gray-500 text-sm">{emptyMessage}</p> : <NoData />}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default DataTable;

